import { Components, Theme } from '@mui/material';

export const MuiPaginationItem = {
  defaultProps: {
    disableRipple: true,
    size: 'small',
  },
  styleOverrides: {
    ellipsis: {
      pointerEvents: 'none',
    },
    sizeSmall: {
      height: 20,
      minWidth: 20,
    }
  }
} as Components<Theme>['MuiPaginationItem'];